import styled from '@emotion/styled'

export default styled.div`
	> * {
		margin: 0 calc(var(--spacing) / 2);
	}

	margin: 0 calc(var(--spacing) / -2);
	display: flex;
`
